import { FIELDS } from './types';
import { Validator } from 'utils/form/validation/types';
import { postcodeValidation, nullableString } from 'utils/form/validation';

const AVAILABLE_FIELDS = [
  FIELDS.POSTCODE,
  FIELDS.FLAT_NUMBER,
  FIELDS.BUILDING_NAME,
  FIELDS.BUILDING_NUMBER,
  FIELDS.STREET,
  FIELDS.CITY,
  FIELDS.COUNTY,
];

const AllFields: any = (required: boolean = true) => ({
  [FIELDS.POSTCODE]: required
    ? postcodeValidation()
        .nullable()
        .required('Post Code is required')
    : postcodeValidation().nullable(),
  [FIELDS.FLAT_NUMBER]: nullableString(),
  [FIELDS.BUILDING_NAME]: nullableString().test({
    name: 'Is building name or building number populated',
    test: function(buildingName) {
      const { buildingNumber } = this.parent;

      if (!buildingName && !buildingNumber) {
        return this.createError({
          message: `One of Building Number and Building Name must not be empty.`,
        });
      }

      return true;
    },
  }),
  [FIELDS.BUILDING_NUMBER]: nullableString().test({
    name: 'Is building name or building number populated',
    test: function(buildingNumber) {
      const { buildingName } = this.parent;

      if (!buildingName && !buildingNumber) {
        return this.createError({
          message: `One of Building Number and Building Name must not be empty.`,
        });
      }

      return true;
    },
  }),
  [FIELDS.STREET]: nullableString().notRequired(),
  [FIELDS.CITY]: required
    ? nullableString()
        .min(3, 'City field must have at least 3 characters.')
        .required('City is required')
    : nullableString(),
  [FIELDS.COUNTY]: nullableString(),
});

const templatesShapeMapper = (fieldName: string, required: boolean = true) => {
  const map: any = {
    [FIELDS.FULL_ADDRESS]: AllFields(required),
  };

  return map[fieldName] || {};
};

export default {
  getShape: (fields: Array<string>, shouldValidate: boolean = true) => {
    const templateShapes = fields
      .map((fieldName) => templatesShapeMapper(fieldName, shouldValidate))
      .filter((shape) => Object.getOwnPropertyNames(shape).length > 0);

    const templateShapeEntries = templateShapes.flatMap((templateShape) =>
      Object.keys(templateShape).map((criteriaName) => [criteriaName, templateShape[criteriaName]]),
    );

    const shape = fields
      .filter((fieldName: string) => fieldName in AVAILABLE_FIELDS)
      .map((fieldName: string) => {
        return [fieldName, AllFields(shouldValidate)[fieldName]];
      });

    return { ...Object.fromEntries(shape), ...Object.fromEntries(templateShapeEntries) };
  },
} as Validator;
